// import React, { useState } from "react";
// import Navbar from "../Misc/Navbar";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { useNavigate } from "react-router-dom";
// import bcrypt from "bcryptjs";
// import { Link } from "react-router-dom";
// import { TextField } from "@mui/material";
// import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import eye icons for password visibility toggle
// import "../Authentication/signup.component.css";

// export default function SignUp() {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     password: "",
//   });

//   const [errors, setErrors] = useState({
//     password: "",
//   });

//   const [showPassword, setShowPassword] = useState(false); // State to handle password visibility

//   const handleInputChange = (event) => {
//     const { name, value } = event.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleInputChange_name = (event) => {
//     const { name, value } = event.target;
//     const regex = /^[a-zA-Z]*$/;
//     if (regex.test(value)) {
//       setFormData({
//         ...formData,
//         [name]: value,
//       });
//     }
//   };

//   const validatePassword = (password) => {
//     const passwordRegex =
//       /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
//     return passwordRegex.test(password);
//   };

//   const handleLogin = async (event) => {
//     event.preventDefault();

//     if (!validatePassword(formData.password)) {
//       setErrors({
//         password:
//           "Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character.",
//       });
//       return;
//     }

//     const hashedPassword = await bcrypt.hash(formData.password, 10);

//     const loginData = {
//       name: formData.name,
//       email: formData.email,
//       password: hashedPassword,
//     };

//     axios
//       .post("https://raasbackend.vetrinahealthcare.com/Signup_view/", loginData)
//       .then((response) => {
//         console.log("SignUp Successful:", response.data);

//         Swal.fire({
//           icon: "success",
//           title: "SignUp Successful!",
//           text: "You can perform additional actions after successful signup.",
//           timer: 1000,
//           timerProgressBar: true,
//           showConfirmButton: false,
//         });

//         navigate("/sign-in");
//       })
//       .catch((error) => {
//         console.error("SignUp Error:", error);

//         Swal.fire({
//           icon: "error",
//           title: "SignUp Error",
//           text: "There was an error during signup. Please try again.",
//           timer: 4000,
//           timerProgressBar: true,
//           showConfirmButton: false,
//         });
//       });
//   };

//   return (
//     <div className="signups-container">
//       <Navbar />
//       <div className="signups-content">
//         <div className="signups-box">
//           <form onSubmit={handleLogin}>
//             <h2>Sign Up</h2>
//             <div className="mb-3 mt-5">
//               <TextField
//                 fullWidth
//                 color="secondary"
//                 type="name"
//                 required
//                 name="name"
//                 value={formData.name}
//                 label="Name"
//                 onChange={handleInputChange_name}
//               />
//             </div>
//             <div className="mb-3">
//               <TextField
//                 fullWidth
//                 color="secondary"
//                 type="email"
//                 required
//                 name="email"
//                 value={formData.email}
//                 label="Email"
//                 onChange={handleInputChange}
//               />
//             </div>
//             <div className="mb-3 position-relative">
//               <TextField
//                 fullWidth
//                 type={showPassword ? "text" : "password"} // Toggle between text and password
//                 required
//                 name="password"
//                 color="secondary"
//                 value={formData.password}
//                 label="Password"
//                 onChange={handleInputChange}
//               />
//               {/* Eye icon to toggle password visibility */}
//               <div
//                 className="eye-icon"
//                 onClick={() => setShowPassword(!showPassword)} // Toggle visibility on click
//                 style={{
//                   cursor: "pointer",
//                   position: "absolute",
//                   right: "30px", // Adjust the positioning to fit in the input field
//                   top: "10px",
//                   fontSize: "25px", // Adjust icon size if needed
//                 }}
//               >
//                 {showPassword ? <FaEyeSlash /> : <FaEye />} {/* Show or hide icon */}
//               </div>
//               {errors.password && (
//                 <div className="error-text">{errors.password}</div>
//               )}
//             </div>
//             <div className="d-grid">
//               <button type="submit" className="btn-shiny2" style={{ margin: "auto auto" }}>
//                 Create Account
//               </button>
//             </div>
//             <p className="forgot-password text-center">
//               Already registered <Link to="/sign-in">sign-in?</Link>
//             </p>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// }


// import React, { useState } from "react";
// import Navbar from "../Misc/Navbar";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { useNavigate, Link } from "react-router-dom";
// import bcrypt from "bcryptjs";
// import { TextField } from "@mui/material";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import "../Authentication/signup.component.css"; // Ensure this path is correct

// export default function SignUp() {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     password: "",
//   });

//   const [errors, setErrors] = useState({
//     password: "",
//   });

//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const handleInputChange = (event) => {
//     const { name, value } = event.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleInputChange_name = (event) => {
//     const { name, value } = event.target;
//     const regex = /^[a-zA-Z\s_]*$/;
//     if (regex.test(value)) {
//       setFormData({
//         ...formData,
//         [name]: value,
//       });
//     }
//   };

//   const validatePassword = (password) => {
//     const passwordRegex =
//       /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
//     if (!passwordRegex.test(password)) {
//       setErrors({
//         password:
//           "Password must be 8+ characters, with uppercase, lowercase, number, & special character.",
//       });
//       return false;
//     }
//     setErrors({ password: "" });
//     return true;
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     if (!validatePassword(formData.password)) {
//       return;
//     }
//     setLoading(true);
//     try {
//       const hashedPassword = await bcrypt.hash(formData.password, 10);
//       const signupData = {
//         name: formData.name,
//         email: formData.email,
//         password: hashedPassword,
//       };
//       const response = await axios.post("https://raasbackend.vetrinahealthcare.com/Signup_view/", signupData);
//       console.log("SignUp Successful:", response.data);
//       Swal.fire({
//         icon: "success",
//         title: "SignUp Successful!",
//         text: "You can now sign in with your new account.",
//         timer: 2000,
//         timerProgressBar: true,
//         showConfirmButton: false,
//       }).then(() => {
//         navigate("/sign-in");
//       });
//     } catch (error) {
//       console.error("SignUp Error:", error);
//       let errorMessage = "There was an error during signup. Please try again.";
//       if (error.response && error.response.data && error.response.data.message) {
//         errorMessage = error.response.data.message;
//       } else if (error.response && error.response.status === 400) {
//         errorMessage = "Email already exists or invalid data provided.";
//       }
//       Swal.fire({
//         icon: "error",
//         title: "SignUp Error",
//         text: errorMessage,
//         timer: 4000,
//         timerProgressBar: true,
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="signups-container">
//       <Navbar />
//       <div className="signups-form-wrapper"> {/* Matched to login's .form-wrapper */}
//         <h2 className="signup-heading-outside"> {/* Matched to login's class pattern */}
//           From Hiring to High Performance – All in One Place.
//         </h2>
        
//         <div className="signups-box"> {/* This is like signupLogin-box */}
//           <form onSubmit={handleSubmit}>
//             <h3 className="signup-form-title">Sign Up</h3>
//             <div className="mb-3 mt-4">
//               <TextField
//                 fullWidth
//                 color="secondary"
//                 type="text"
//                 required
//                 name="name"
//                 value={formData.name}
//                 label="Full Name"
//                 onChange={handleInputChange_name}
//                 variant="outlined"
//               />
//             </div>
//             <div className="mb-3">
//               <TextField
//                 fullWidth
//                 color="secondary"
//                 type="email"
//                 required
//                 name="email"
//                 value={formData.email}
//                 label="Email Address"
//                 onChange={handleInputChange}
//                 variant="outlined"
//               />
//             </div>
//             <div className="mb-3 position-relative">
//               <TextField
//                 fullWidth
//                 type={showPassword ? "text" : "password"}
//                 required
//                 name="password"
//                 color="secondary"
//                 value={formData.password}
//                 label="Password"
//                 onChange={handleInputChange}
//                 variant="outlined"
//                 error={!!errors.password}
//               />
//               <div
//                 className="eye-icon-signup"
//                 onClick={() => setShowPassword(!showPassword)}
//               >
//                 {showPassword ? <FaEyeSlash /> : <FaEye />}
//               </div>
//               {errors.password && (
//                 <div className="error-text-signup">{errors.password}</div>
//               )}
//             </div>
//             <div className="d-grid mt-4">
//               <button
//                 type="submit"
//                 className="btn-shiny2"
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
//                 ) : (
//                   "Create Account"
//                 )}
//               </button>
//             </div>
//             <p className="login-link-text text-center mt-3">
//               Already registered? <Link to="/sign-in">Sign In</Link>
//             </p>
//           </form>
//         </div>

//         <p className="signup-description-outside"> {/* Matched to login's class pattern */}
//           Entire employee journey from being hired, onboarding, receiving training, setting goals, to growing and excelling in your role is supported through one easy-to-use system. It ensures a smooth, connected experience that helps you succeed and perform at your best.
//         </p>
//       </div>
//     </div>
//   );
// }




// import React, { useState } from "react";
// import Navbar from "../Misc/Navbar";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { useNavigate, Link } from "react-router-dom";
// import bcrypt from "bcryptjs";
// import { TextField, InputAdornment, IconButton } from "@mui/material";
// import { FaEye, FaEyeSlash } from "react-icons/fa";


// export default function SignUp() {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     password: "",
//   });

//   const [errors, setErrors] = useState({
//     password: "",
//   });

//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const handleInputChange = (event) => {
//     const { name, value } = event.target;
//     setFormData({ ...formData, [name]: value });
//     if (name === "password") {
//         if (value === "" || validatePassword(value, false)) {
//              setErrors(prevErrors => ({ ...prevErrors, password: "" }));
//         }
//     }
//   };

//   const handleInputChange_name = (event) => {
//     const { name, value } = event.target;
//     const regex = /^[a-zA-Z\s_]*$/;
//     if (regex.test(value) || value === "") {
//       setFormData({
//         ...formData,
//         [name]: value,
//       });
//     }
//   };

//   const validatePassword = (password, seterror = true) => {
//     const passwordRegex =
//       /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
//     if (!passwordRegex.test(password)) {
//       if (seterror) {
//         setErrors({
//           password:
//             "8+ chars, with uppercase, lowercase, number, & special char.",
//         });
//       }
//       return false;
//     }
//     if (seterror) {
//         setErrors({ password: "" });
//     }
//     return true;
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     if (!validatePassword(formData.password)) {
//       return;
//     }
//     setLoading(true);
//     try {
//       const hashedPassword = await bcrypt.hash(formData.password, 10);
//       const signupData = {
//         name: formData.name,
//         email: formData.email,
//         password: hashedPassword,
//       };
//       const response = await axios.post("https://raasbackend.vetrinahealthcare.com/Signup_view/", signupData);
//       console.log("SignUp Successful:", response.data);
//       Swal.fire({
//         icon: "success",
//         title: "SignUp Successful!",
//         text: "You can now sign in with your new account.",
//         timer: 2000,
//         timerProgressBar: true,
//         showConfirmButton: false,
//       }).then(() => {
//         navigate("/sign-in");
//       });
//     } catch (error) {
//       console.error("SignUp Error:", error);
//       let errorMessage = "An unexpected error occurred. Please try again.";
//       if (error.response) {
//         const errorData = error.response.data;
//         if (errorData && (errorData.message || errorData.error || errorData.detail || (typeof errorData === 'string' && errorData.length < 100))) {
//           errorMessage = errorData.message || errorData.error || errorData.detail || errorData;
//         } else if (error.response.status === 400) {
//           errorMessage = "Email may already exist or provided data is invalid.";
//         } else if (error.response.status === 500) {
//           errorMessage = "Server error. Please try again later.";
//         }
//       } else if (error.request) {
//         errorMessage = "No response from server. Check your network connection.";
//       }
      
//       Swal.fire({
//         icon: "error",
//         title: "SignUp Error",
//         text: errorMessage,
//         timer: 4000,
//         timerProgressBar: true,
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="login-page-container"> 
//       <Navbar />
//       <div className="fullscreen-background"> 
//         <div className="form-wrapper"> 
//           <h2 className="login-heading-outside"> 
//             From Hiring to High Performance – All in One Place.
//           </h2>
          
//           <div className="signupLogin-box" style={{ padding: '10px 35px' }}>

//             <form onSubmit={handleSubmit}>
//               <h3 className="form-title">Sign Up</h3> 
              
//               <TextField
//                 fullWidth
//                 type="text"
//                 required
//                 name="name"
//                 value={formData.name}
//                 label="Full Name"
//                 onChange={handleInputChange_name}
//                 variant="outlined"
//                 size="small"
//                 margin="normal"
//               />
            
//               <TextField
//                 fullWidth
//                 type="email"
//                 autoComplete="email"
//                 required
//                 name="email"
//                 value={formData.email}
//                 label="Email Address"
//                 onChange={handleInputChange}
//                 variant="outlined"
//                 size="small"
//                 margin="normal"
//               />
           
//             <TextField
//                 fullWidth
//                 type={showPassword ? "text" : "password"}
//                 autoComplete="new-password"
//                 required
//                 name="password"
//                 value={formData.password}
//                 label="Password"
//                 onChange={handleInputChange}
//                 variant="outlined"
//                 error={!!errors.password}
//                 helperText={errors.password || " "} /* Shows error or maintains space */
//                 FormHelperTextProps={{ 
//                     className: 'error-text-signup' // Apply custom class if needed beyond MUI default
//                 }}
//                 size="small"
//                 margin="normal"
//                 InputProps={{
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton
//                         aria-label="toggle password visibility"
//                         onClick={() => setShowPassword(!showPassword)}
//                         onMouseDown={(e) => e.preventDefault()} 
//                         edge="end"
//                         className="eye-icon-signup" 
//                       >
//                         {showPassword ? <FaEyeSlash /> : <FaEye />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />

//               <div className="d-grid mt-3">
//                 <button
//                   type="submit"
//                   className="btn-shiny2"
//                   disabled={loading}
//                 >
//                   {loading ? (
//                     <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
//                   ) : (
//                     "Create Account"
//                   )}
//                 </button>
//               </div>

//               <p className="login-link-text text-center mt-3">
//                 Already registered? <Link to="/sign-in">Sign In</Link>
//               </p>
//             </form>
//           </div>

//           <p className="login-description-outside"> 
//             Entire employee journey from being hired, onboarding, receiving training, setting goals, to growing and excelling in your role is supported through one easy-to-use system. It ensures a smooth, connected experience that helps you succeed and perform at your best.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState } from "react";
import Navbar from "../Misc/Navbar";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate, Link } from "react-router-dom";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export default function SignUp() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  // General input handler for Email and Password
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
    if (name === "password") {
      if (value === "" || validatePassword(value, false)) {
        setErrors((prevErrors) => ({ ...prevErrors, password: "" }));
      }
    }
  };

  // Specific handler for Name (Username) to allow only letters and spaces
  const handleInputChange_name = (event) => {
    const { name, value } = event.target;
    const regex = /^[a-zA-Z\s_]*$/;
    if (regex.test(value) || value === "") {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const validatePassword = (password, seterror = true) => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!passwordRegex.test(password)) {
      if (seterror) {
        setErrors({
          password:
            "8+ chars, with uppercase, lowercase, number, & special char.",
        });
      }
      return false;
    }
    if (seterror) {
      setErrors({ password: "" });
    }
    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validatePassword(formData.password)) {
      return;
    }
    setLoading(true);

    // FIXED: Sending Plain Text password (Backend handles hashing)
    const signupData = {
      name: formData.name,
      email: formData.email,
      password: formData.password, 
    };

    try {
      const response = await axios.post(
        "https://raasbackend.vetrinahealthcare.com/Signup_view/",
        signupData
      );
      console.log("SignUp Successful:", response.data);
      Swal.fire({
        icon: "success",
        title: "SignUp Successful!",
        text: "You can now sign in with your new account.",
        timer: 2000,
        timerProgressBar: true,
        showConfirmButton: false,
      }).then(() => {
        navigate("/sign-in");
      });
    } catch (error) {
      console.error("SignUp Error:", error);
      let errorMessage = "An unexpected error occurred. Please try again.";
      if (error.response) {
        const errorData = error.response.data;
        if (
          errorData &&
          (errorData.message ||
            errorData.error ||
            errorData.detail ||
            (typeof errorData === "string" && errorData.length < 100))
        ) {
          errorMessage =
            errorData.message || errorData.error || errorData.detail || errorData;
        } else if (error.response.status === 400) {
          errorMessage = "Email may already exist or provided data is invalid.";
        } else if (error.response.status === 500) {
          errorMessage = "Server error. Please try again later.";
        }
      } else if (error.request) {
        errorMessage = "No response from server. Check your network connection.";
      }

      Swal.fire({
        icon: "error",
        title: "SignUp Error",
        text: errorMessage,
        timer: 4000,
        timerProgressBar: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page-container">
      <Navbar />
      <div className="fullscreen-background">
        <div className="form-wrapper">
          <h2 className="login-heading-outside">
            From Hiring to High Performance – All in One Place.
          </h2>

          <div className="signupLogin-box" style={{ padding: "10px 35px" }}>
            <form onSubmit={handleSubmit}>
              <h3 className="form-title">Sign Up</h3>

              {/* NAME / USERNAME FIELD */}
              <TextField
                fullWidth
                type="text"
                required
                name="name"
                value={formData.name}
                label="Full Name"
                onChange={handleInputChange_name}
                variant="outlined"
                size="small"
                margin="normal"
              />

              <TextField
                fullWidth
                type="email"
                autoComplete="email"
                required
                name="email"
                value={formData.email}
                label="Email Address"
                onChange={handleInputChange}
                variant="outlined"
                size="small"
                margin="normal"
              />

              <TextField
                fullWidth
                type={showPassword ? "text" : "password"}
                autoComplete="new-password"
                required
                name="password"
                value={formData.password}
                label="Password"
                onChange={handleInputChange}
                variant="outlined"
                error={!!errors.password}
                helperText={errors.password || " "}
                FormHelperTextProps={{
                  className: "error-text-signup",
                }}
                size="small"
                margin="normal"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword(!showPassword)}
                        onMouseDown={(e) => e.preventDefault()}
                        edge="end"
                        className="eye-icon-signup"
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <div className="d-grid mt-3">
                <button
                  type="submit"
                  className="btn-shiny2"
                  disabled={loading}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    "Create Account"
                  )}
                </button>
              </div>

              <p className="login-link-text text-center mt-3">
                Already registered? <Link to="/sign-in">Sign In</Link>
              </p>
            </form>
          </div>

          <p className="login-description-outside">
            Entire employee journey from being hired, onboarding, receiving
            training, setting goals, to growing and excelling in your role is
            supported through one easy-to-use system. It ensures a smooth,
            connected experience that helps you succeed and perform at your
            best.
          </p>
        </div>
      </div>
    </div>
  );
}